import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	jira_advanced_search: {
		id: 'jira_advanced_search',
		defaultMessage: 'Jira Advanced Search',
		description: 'Label for when the user wants to navigate to a advanced issue search on Jira',
	},
});
